import { BackOfficeUserListModelDto } from '@treasury/api/bo';
import { DomainEntity } from '@treasury/domain/shared';

const nullFiUser: BackOfficeUserListModelDto = {
    isActiveUser: false,
    isUserAdmin: false,
    isSuperUser: false,
    isAccountAdmin: false,
    isReportsAdmin: false,
    isLocked: false,
    isMfaBlocked: false,
    isTokenMfaLocked: false,
    isEnrolled: false,
    id: 0,
    backOfficeSsoEnabled: false,
};

export class FiUser extends DomainEntity<BackOfficeUserListModelDto> {
    constructor(dto = nullFiUser) {
        super(dto);
    }

    public createDefault(): this {
        return new FiUser(nullFiUser) as this;
    }

    public get name() {
        return this.dto.userName;
    }

    public get loginId() {
        return this.dto.alias;
    }

    public get roles() {
        return this.dto.roles?.map(role => role.name) || [];
    }

    public get status() {
        return this.dto.status;
    }

    public get isActiveUser() {
        return this.dto.isActiveUser;
    }

    public get isLocked() {
        return this.dto.isLocked;
    }

    public get isMfaLocked() {
        return this.dto.isTokenMfaLocked;
    }

    public get id() {
        return this.dto.id;
    }
}
